export { default } from "~/pages/resource/index";

import { paths, getListingProps } from "~/modules/static-paths";

export async function getStaticPaths() {
    return { paths: await paths.blogPages(), fallback: false };
}

export async function getStaticProps({ params }) {
    return getListingProps({ type: "posts", page: params.page });
}
